module.exports = __webpack_public_path__ + "media/sfx_error.66d2b735.mp3";